export default Object.freeze({
  COMPANION_EDUCATIONAL: 'Acompañante Educativo',
  ADDITION_EDUCATIONAL: 'Aditamento Educativo',
  COMPANION_THERAPY: 'Acompañante Terapia',
  ADDITION_THERAPY: 'Aditamento Terapia',
});
